import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import Buefy from 'buefy'
import DateRangePicker from 'vue-rangedate-picker';
import JsonCSV from 'vue-json-csv'
import VueApexCharts from 'vue-apexcharts'
import axios from 'axios'


Vue.component('downloadCsv', JsonCSV)
Vue.component('vuejs-daterangepicker', DateRangePicker);
Vue.component('apexchart', VueApexCharts)

Vue.use(VueApexCharts)
Vue.use(DateRangePicker)
Vue.use(Buefy)

Vue.config.productionTip = false;

axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {
    if (error && error.response && error.response.status == 401) {
        localStorage.removeItem("jwt")
    }
    if (error && error.response && error.response.status == 403) {
        localStorage.removeItem("jwt")
    }
    return Promise.reject(error);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
